import { supabase } from './supabase';

function normalizePhone(phone) {
  if (!phone) return null;
  let p = phone.replace(/\D/g, '');
  if (p.startsWith('0')) p = '994' + p.slice(1);
  if (!p.startsWith('994') && p.length === 9) p = '994' + p;
  return p;
}

async function sendTemplate(to, templateName, params, buttonUrl = null) {
  const { error } = await supabase.functions.invoke('send-whatsapp', {
    body: { to, template: templateName, params, buttonUrl },
  });
  if (error) console.error(`[WA] ${templateName} error:`, error.message);
  else console.log(`[WA] ${templateName} → ${to} göndərildi`);
}

// ── Menecerə: yeni rezervasiya sorğusu ───────────────────────────────────────
export async function sendNewBookingAlert(managerPhone, booking) {
  const to = normalizePhone(managerPhone);
  if (!to) return;

  await sendTemplate(to, 'yeni_rezervasiya_bildirisi', [
    booking.contact_name || booking.guest_name || 'Naməlum',
    booking.contact_phone || '—',
    booking.reservation_date || '—',
    (booking.reservation_time || '').slice(0, 5) || '—',
    String(booking.party_size || booking.guest_count || '—'),
    String(booking.table_number || '—'),
  ]);
}

// ── İstifadəçiyə: rezervasiya təsdiqləndi ────────────────────────────────────
export async function sendBookingConfirmedToUser(userPhone, booking, businessName, businessAddress) {
  const to = normalizePhone(userPhone);
  if (!to) return;

  const mapQuery = encodeURIComponent(businessAddress || businessName || 'Cafegoo');

  await sendTemplate(to, 'rezervasiya_tesdiqi', [
    businessName || '—',
    booking.contact_name || booking.guest_name || 'Naməlum',
    booking.reservation_date || '—',
    (booking.reservation_time || '').slice(0, 5) || '—',
    String(booking.party_size || booking.guest_count || '—'),
    String(booking.table_number || '—'),
  ], mapQuery);
}

/**
 * cetdirilme_qebul_edildi → müştəriyə (kafe qəbul edəndə)
 *   {{1}} Kafe adı
 */
export async function sendDeliveryAcceptedToUser(userPhone, businessName) {
  const to = normalizePhone(userPhone);
  if (!to) return;
  await sendTemplate(to, 'cetdirilme_qebul_edildi', [businessName || '—']);
}

/**
 * cetdirilme_redd_edildi → müştəriyə (kafe rədd edəndə)
 *   {{1}} Kafe adı, {{2}} Səbəb
 */
export async function sendDeliveryRejectedToUser(userPhone, businessName, reason) {
  const to = normalizePhone(userPhone);
  if (!to) return;
  await sendTemplate(to, 'cetdirilme_redd_edildi', [businessName || '—', reason || 'Səbəb göstərilməyib']);
}

/**
 * cetdirilme_catdirildi → müştəriyə (öz kuryer "Çatdırıldı" işarələyəndə)
 *   {{1}} Kafe adı
 */
export async function sendDeliveryCompletedToUser(userPhone, businessName) {
  const to = normalizePhone(userPhone);
  if (!to) return;
  await sendTemplate(to, 'cetdirilme_catdirildi', [businessName || '—']);
}
